module.exports = __webpack_public_path__ + "img/组 126.1fee4c95.png";